

const AboutHero = () => {
  return (
    <section className="relative pt-32 pb-20 px-6">
      <div 
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%231B3A52' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}
      ></div>
      
      <div className="relative max-w-5xl mx-auto text-center">
        <p className="text-xs text-gray-500 uppercase tracking-wider mb-5">(About Pastor Don)</p>
        <h1 className="text-5xl md:text-6xl font-serif font-bold text-[#1B3A52] mb-6 leading-tight">
          Shepherd, Teacher, <span className="font-bold text-[#1B3A52]">Author</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-3xl mx-auto">
          A life devoted to serving God's people and sharing the transformative power of His Word through ministry and the written page.
        </p>
      </div>
    </section>
  );
};

export default AboutHero;
